module.exports = __webpack_public_path__ + "img/takeases.2e879321.avif";